import { isUS } from "../components/Registration/countriesList";

export const allowedStreetCityCharsRegex = /^[a-zA-Z0-9\s.'&#/,-]+$/;
export const allowedZipCodeCharsRegex = /^[a-zA-Z0-9\s-]+$/;
export const allowedTaxIdCharsRegex = /^[a-zA-Z0-9\s-]+$/;

export const allowedIndividualNameCharsRegex =
  // eslint-disable-next-line max-len
  /^[A-Za-záéíóúñàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðÐÞĞŞİ'-]+([ -][A-Za-záéíóúñàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðÐÞĞŞİ'-]+)*$/;

// allow optionally http or https prefixes, allow www. prefix, validate special chars and domain format
export const websiteFormatRegex =
  /^(?:https?:\/\/)?(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
export const leiCodeCharactersRegex = /^[A-Za-z0-9]+$/;

export const allowedEntityNameCharsRegex = /^[a-zA-Z0-9\s.'&#/,-]+$/;

// Middle names are frequently initials, so unlike first and last names this
// one also admits a period.
export const allowedMiddleNameCharsRegex =
  // eslint-disable-next-line max-len
  /^[A-Za-záéíóúñàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðÐÞĞŞİ'.-]+([ -][A-Za-záéíóúñàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ðÐÞĞŞİ'.-]+)*$/;

// We won't allow US country with no state
export const areCountryCodeAndStateValid = (
  countryCode: string | undefined,
  state: string | undefined,
) => {
  return !(isUS(countryCode || "") && !state);
};
